module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2665"
    }
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Meye_9781621369127_epub_c3_r1#d6e1",
      "id": "d7e1"
    }
  }, [_vm._v("INTRODUCCIÓN")])]), _vm._v(" "), _c('p', {
    staticClass: "h",
    attrs: {
      "id": "d7e2715"
    }
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Meye_9781621369127_epub_c3_r1#d6e1",
      "id": "d14e187"
    }
  }, [_vm._v("Búsquedas apasionadas")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2765"
    }
  }, [_vm._v("“Dios ama con gran amor al hombre cuyo corazón revienta de pasión por lo IMPOSIBLE.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e2845"
    }
  }, [_vm._v("—William Booth")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e2895"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("M")]), _vm._v("uchas personas hablan sobre propósito en estos tiempos. Es un tema importante: conocer y entender qué es lo que Dios quiere hacer con nosotros. Cuando entendemos nuestro propósito, tenemos un mapa de rutas delante de nosotros que es una guía útil y necesaria. Sin embargo, si el propósito es nuestro viaje y nuestro destino, entonces la pasión es el combustible que va a llevarnos hasta allá, y es vital que mantengamos una buena reserva de ese combustible. La vida sin propósito y pasión es una vida que no vale la pena vivir. Todos necesitamos una razón para levantarnos cada día y necesitamos encontrar la pasión, la chispa que nos mantiene motivados y avanzando. ¡Necesitamos ser entusiastas! Demasiadas personas caminan con caras largas, pareciendo y sintiéndose indiferentes, aburridas o totalmente agotadas. Pero el corazón del ser humano fue creado para tener pasión, un fuerte deseo de alcanzar algo que está más allá de nosotros mismos. Necesitamos ser capaces de celebrar cada día de nuestra vida, sean cuales sean las circunstancias.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e3445"
    }
  }, [_vm._v("Nos levantamos; vamos a trabajar; nos ocupamos de los niños; asistimos a la iglesia; regresamos a casa; nos vamos a la cama y, al día siguiente, volvemos a comenzar todo de nuevo. Estamos perdiendo tanto nuestra pasión como nuestro propósito, y estamos transmitiendo esa falta de entusiasmo a nuestros hijos. Sin duda alguna, quizá unas vacaciones o una gran victoria de nuestro equipo favorito podrían hacernos despertar de nuestro sopor durante un breve periodo, pero enseguida regresamos a no tener verdadero entusiasmo por la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e3766"
    }
  }, [_vm._v("Estamos aquí para disfrutar de Dios y hacer su voluntad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e3836"
    }
  }, [_vm._v("A lo largo de los siglos, millones de personas se han preguntado: “¿Para qué estoy aquí? ¿Cuál es mi propósito?”. Hay una respuesta sencilla para esas preguntas, pero no todos están dispuestos a aceptarla. Estamos aquí para disfrutar de Dios y hacer su voluntad. Fuimos creados para la complacencia de Él. Él es el Alfa y la Omega, el principio y el fin. Por tanto, Él también debe ser todo lo que hay entremedio, y eso es mucho para que algunas personas lo acepten. Ellos quieren saber lo que Dios va a hacer "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("por ellos")]), _vm._v(", pero deberían preguntar lo que Dios va a hacer "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("por medio de ellos")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4326"
    }
  }, [_vm._v("Eso es algo en lo que Pablo pensaba cada día. Veamos cuántas veces utiliza él estas palabras:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4426"
    }
  }, [_vm._v("“No me atreveré a hablar de nada sino de lo que Cristo ha hecho por medio de mí…”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e4526"
    }
  }, [_vm._v("—ROMANOS 15:18")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4576"
    }
  }, [_vm._v("“Pero el Señor estuvo a mi lado y me dio fuerzas para que por medio de mí se llevara a cabo la predicación del mensaje…”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e4686"
    }
  }, [_vm._v("—2 TIMOTEO 4:17")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e4736"
    }
  }, [_vm._v("“Pero por la gracia de Dios soy lo que soy, y la gracia que él me concedió no fue infructuosa. Al contrario, he trabajado con más tesón que todos ellos, aunque no yo sino la gracia de Dios que está conmigo.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e4876"
    }
  }, [_vm._v("—1 CORINTIOS 15:10")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4946"
    }
  }, [_vm._v("Nacemos, vivimos y morimos. No podemos hacer nada en cuanto a nacer o en cuanto a morir, pero podemos hacer mucho en cuanto a cómo vivimos. Pablo entendía eso, y también lo entendía Pedro. Él fue uno de los primeros discípulos que cometió muchos errores en su ministerio y como uno de los seguidores de Cristo, y, sin embargo, Dios lo utilizó porque él estuvo dispuesto a dar un paso de valentía cuando Jesús lo llamó. Pedro fue lleno de celo, pasión y entusiasmo.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5237"
    }
  }, [_vm._v("Asumir responsabilidad por el modo en que vivimos es valiente. Se necesita valor para aceptar la vida tal como nos viene, y también se necesita valor para estar decidido a aprovecharla al máximo. La vida es demasiado corta para desperdiciarla pecando siempre de prudente o no corriendo riesgos en lugar de perseguir todo lo que podemos llegar a ser. Es momento de emprender la acción y hacer que tu vida cuente: sal de la barca y comienza a trabajar para dejar un legado cuando ya te hayas ido.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e5537"
    }
  }, [_vm._v("La pasión es algo más que un sentimiento")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5587"
    }
  }, [_vm._v("Cuando la mayoría de las personas piensan en pasión, puede que piensen en sexo o en ráfagas de emoción que van y vienen. Consideran la pasión como algo inestable, quizá insatisfactorio y hasta innecesario y, como resultado, normalmente responden a la vida y a las señales de entusiasmo de la siguiente manera: "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("No nos entusiasmemos con esto… Simplemente, vayamos día a día y veamos lo que sucede… Yo no dejo que las cosas me lleven hacia un lado o hacia otro")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5867"
    }
  }, [_vm._v("Cuando sentimos menos, arriesgamos menos. Sin embargo, estoy aquí para decirte que la pasión de la que estoy hablando—un entusiasmo entusiasta—no es un sentimiento que viene y va o un ánimo que esperas tener a fin de actuar con respecto a algo. Pasión es la manera en que enfocas la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e6047"
    }
  }, [_vm._v("Vemos cómo usa Dios la pasión. Todo lo que Él hace es hecho con un propósito, y Él lo hace apasionadamente; lo hace con todo su corazón. Nosotros debemos amar a Dios con todo "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("nuestro")]), _vm._v(" corazón, y hacer todo lo que hacemos con entusiasmo e impulso. Ningún esfuerzo a medias por nuestra parte agradará nunca a Dios, ni tampoco producirá verdadero gozo en nuestras vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e6307"
    }
  }, [_vm._v("Hay un deseo innato en lo profundo de cada uno de nosotros de alcanzar metas que parecen inalcanzables. Estoy hablando de esas esperanzas y sueños que todos tenemos; algunos yacen justamente debajo de la superficie, pero algunos han sido tan profundamente enterrados por tanto tiempo, que se necesitará tiempo para desenterrarlos. Es nuestra naturaleza tener algo hacia lo cual estar avanzando en todo momento. Todos necesitamos algo por lo cual esforzarnos, hacia lo cual trabajar y sobre lo cual soñar. Necesitamos una razón para levantarnos de la cama por la mañana, una que sea más grande que la mera existencia durante otro día. Yo creo que todos tenemos un profundo deseo de ser atrevidos, de salir del molde y vivir al límite. Si alguien nos preguntase, enseguida reconoceríamos que queremos que la vida sea emocionante, pero algunos de nosotros nos hemos vuelto demasiado cómodos al estar sentados en nuestros respectivos sillones de la vida. Necesitamos un desafío, pero sólo algunos de nosotros nos atrevemos alguna vez a seguir el impulso de nuestros corazones. Yo he decidido ser una de esas pocas personas. ¿Quieres unirte a mí? ¿Te atreves a ser diferente? ¿Te atreves a vivir la vida de veras?")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e7078"
    }
  }, [_vm._v("¿Te atreves a vivir la vida de veras?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e7168"
    }
  }, [_vm._v("Como algunas personas, yo pasé muchos años sin disfrutar del viaje de la vida. Yo luchaba contra la vida, al siempre desear tener algo diferente de lo que tenía. Finalmente, aprendí que la vida se trata más del viaje que del destino, e hice el compromiso de disfrutar de todo. Le doy gracias a Dios porque Él me enseñó a afrontar la vida con valentía, al saber que Él está conmigo y que puedo hacer cualquier cosa que necesite hacer con Él a mi lado, y puedo hacerlo con alegría. Ahora sé que tengo un propósito y Dios tiene un plan, y he decidido vivir mis días con pasión y entusiasmo. Creo que este libro tendrá un profundo efecto en ti; también añadirá una calidad a tu vida que puede que hayas perdido, y es mi oración que Dios te muestre el propósito y la pasión que Él quiere que tengas.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e7608"
    }
  }, [_vm._v("Nuestro mayor ejemplo de pasión")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e7658"
    }
  }, [_vm._v("Como cristianos, cuando hablamos sobre pasión, muchos de nosotros pensaremos en las películas sobre la pasión que hemos visto en Semana Santa y, desde luego, en la película el año 2004, "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("La pasión de Cristo")]), _vm._v(", que muestra las últimas doce horas de la vida de Jesús en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e7919"
    }
  }, [_vm._v("Jesús era apasionado con respecto a su propósito. Y Él no lo mostraba solamente en los momentos intensos y emocionales, como cuando se enojó al ver personas vender sus mercancías en el templo o cuando lloró al ver la incredulidad de la gente. Su pasión podía verse en su interés por los enfermos, los pobres y quienes eran tratados injustamente. Él siempre se detenía para ayudar y consolar a personas heridas que acudían a Él. Él oraba apasionadamente, y mostró un gran aguante mientras estaba en la cruz. Él amaba a su Padre apasionadamente. Podemos decir sin temor a equivocarnos que todo lo que Jesús hacía, lo hacía de todo corazón, y nosotros deberíamos seguir su ejemplo.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e8299"
    }
  }, [_vm._v("Cuando pensamos en pasión, tenemos que pensar en la pasión de Cristo. Necesitamos recordar su enfoque, su determinación, y lo mucho que participaba en la vida y en el plan de su Padre. Necesitamos adoptar su pasión para nosotros. Necesitamos participar tanto en la vida como Él lo hizo y lo hace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e8479"
    }
  }, [_vm._v("Si quieres sacar el mayor partido a tu vida y vivirla con entusiasmo y celo del modo en que Jesús lo hizo, solamente leer este libro no será suficiente. Tendrás que tomar decisiones a lo largo del camino; puede que tengas que cambiar tu modo de enfocar la vida; puede que tu actitud y el modo en que empleas tu tiempo tengan que cambiar. Sin embargo, los resultados serán gratificantes. Levantarte cada día con propósito y vivir cada día apasionadamente es una recompensa en sí. Añade más valor a la vida, y, al final de cada día, podemos sentir satisfacción, realización. Podemos esperar el día siguiente con expectación.")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e8829"
    }
  }, [_vm._v("Vivir cada día apasionadamente es una recompensa en sí.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e8879"
    }
  }, [_vm._v("Cuando abrazamos la vida con pasión, no experimentaremos tanto pavor o lamentos. Nuestras vidas se vuelven llenas de celo por el presente, y somos lo que yo denomino una persona del “AHORA”. Alguien que vive plenamente en el presente y saca el máximo partido de cada día. Hasta los “baches” que hay en la carretera del viaje de la vida tienen un propósito, y puedes aprender a encontrar valor en ellos en lugar de temerles y despreciarlos.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e91510"
    }
  }, [_vm._v("Haz este viaje conmigo. Aprendamos juntos cómo podemos ser más apasionados por la vida que Dios nos ha dado. Tengamos la determinación de cumplir nuestro propósito.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0deb1b55","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Meye_9781621369127_epub_c4_r1.vue
// module id = 66
// module chunks = 0